module.exports = __webpack_public_path__ + "img/healthy-tea-leaves 3.8e67d82a.jpg";